import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageService } from 'src/app/services/language.service';

@Component({
    selector: 'confirm-question',
    template:`
    <div class="modal-header">
  <h4 class="modal-title">{{message}}</h4>
    <button type="button" class="close" style="margin-left: 0;" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger m-1" (click)="dismiss()">{{ no }}</button>
    <button type="button" class="btn btn-primary m-1" (click)="accept()">{{ yes }}</button>
  </div>
    `
})

export class QuestionComponent implements OnInit {
    constructor(private activeModal: NgbActiveModal,
      private languageService:LanguageService) { }
      //1 delele
      //2 add or edit
      //3 havale
      //
      yes:string="";
      no:string="";
    message:string;
    @Input() flag:number;
    ngOnInit() {
      this.yes = this.languageService.translate('yes');
      this.no = this.languageService.translate('no');
      switch (this.flag) {
        case 1:
          this.message = this.languageService.translate('doYouWantToDelete')
          break;
        case 2:
          this.message = this.languageService.translate('doYouWantToAddorEdit')
          break;
        case 3:
          this.message = this.languageService.translate('hasTheTransferBeenRegistered')
          break;
        case 4:
          this.message = this.languageService.translate('doYouWantToExit');
          break;
        default:
            this.message = this.languageService.translate('hasTheTransferBeenRegistered')
          break;
      }
    }

    public accept() {
        this.activeModal.close(true);
      }
    
      public dismiss() {
        this.activeModal.close(false);
      }
}